import { render, staticRenderFns } from "./guandongInvest.vue?vue&type=template&id=7426897d&scoped=true&"
import script from "./guandongInvest.vue?vue&type=script&lang=js&"
export * from "./guandongInvest.vue?vue&type=script&lang=js&"
import style0 from "./guandongInvest.vue?vue&type=style&index=0&id=7426897d&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7426897d",
  null
  
)

export default component.exports